import { Container, Box, Text } from '@chakra-ui/react';

const Footer = () => {
    return (
        <Box
          marginTop={10}
          borderTopWidth={1}
          borderTop='solid'
          borderTopColor='primary.grey3'
          boxShadow='0px 1px 2px rgba(151, 151, 151, 0.05)'
        >
          <Container maxW='container.xl' padding='1.5rem 3rem'>
            <Text color='primary.grey' fontSize='md' fontWeight={500}>
              © 2022 Ollie, Inc. · Privacy · Conditions · Site Map · Company data
            </Text>
          </Container>
        </Box>
    );
}

export {Footer};